import { sendWebsocketMessage } from '../../../../../App';
/**
 * removes the watchlist from the datasource's symbols stream
 *
 * @param {*} id of the watchlist that these option chains link to
 * @param {*} dataSource that the option chain is getting quotes from
 */
export function releaseOptionChains(id, dataSource) {
  const msg = {
    messageType: 'releaseOptionChains',
    id,
    dataSource,
  };
  sendWebsocketMessage(msg);
}
